const normalize = value => String(value || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

export const hasLocationIntent = text => /\b(cerca de mi|cerca de donde estoy|cercan[oa]s?|por aqui|a mi alrededor|alrededor mio|lo mas proxim[oa]|que hay cerca|algo cerca|a poca distancia|caminando|usa mi ubicacion|desde aqui)\b/i.test(normalize(text));

export const LOCATION_ACTION_TYPES = Object.freeze({
  DON_D_RECOMMENDATION: "DON_D_RECOMMENDATION",
  NAVIGATE_TO_PLACE: "NAVIGATE_TO_PLACE",
  REGISTER_PLACE: "REGISTER_PLACE",
  ONBOARDING_LOCATION: "ONBOARDING_LOCATION",
  NEARBY_SEARCH: "NEARBY_SEARCH",
});

export const createPendingLocationAction = (type, details = {}) => ({
  type,
  ...details,
  createdAt: Date.now(),
});
